import { ApiResponse, axiosInstance } from '@/lib/axios';
import { queryOptions, useQuery } from '@tanstack/react-query';
import { QueryConfig } from '@/lib/react-query';
import { TCASTQuestionConfig } from '../types/customer-survey.type';

/**
 * Get List CAST Question Config Response Type
 */

export type TGetListCASTQuestionConfigResponse = ApiResponse<TCASTQuestionConfig[]>;

export const getListCASTQuestionConfig = async (): Promise<TGetListCASTQuestionConfigResponse> => {
  const url = '/csat/config/question';

  return axiosInstance.get(url);
};

/**
 * Get List CAST Question Config React-Query Hook
 */
export const GET_LIST_CAST_QUESTION_CONFIG_QUERY_KEY = 'get-list-cast-question-config';

export const getListCASTQuestionConfigQueryOptions = <TData = TCASTQuestionConfig[]>(
  select?: (data: TGetListCASTQuestionConfigResponse) => TData
) => {
  return queryOptions({
    queryKey: [GET_LIST_CAST_QUESTION_CONFIG_QUERY_KEY],
    queryFn: () => getListCASTQuestionConfig(),
    select,
  });
};

// Overload when select is provided - returns transformed type
export function useGetListCASTQuestionConfigQuery<TData>(options: {
  queryConfig?: QueryConfig<typeof getListCASTQuestionConfigQueryOptions<TData>>;
  select: (data: TGetListCASTQuestionConfigResponse) => TData;
}): ReturnType<typeof useQuery<TData>>;

// Overload when select is not provided - returns raw API response (even if generic is provided)
export function useGetListCASTQuestionConfigQuery(options: {
  queryConfig?: QueryConfig<typeof getListCASTQuestionConfigQueryOptions<TGetListCASTQuestionConfigResponse>>;
}): ReturnType<typeof useQuery<TGetListCASTQuestionConfigResponse>>;

// Implementation
export function useGetListCASTQuestionConfigQuery<TData = TGetListCASTQuestionConfigResponse>({
  queryConfig,
  select,
}: {
  queryConfig?: QueryConfig<typeof getListCASTQuestionConfigQueryOptions<TData | TGetListCASTQuestionConfigResponse>>;
  select?: (data: TGetListCASTQuestionConfigResponse) => TData;
}) {
  return useQuery({
    ...getListCASTQuestionConfigQueryOptions(select),
    ...queryConfig,
  }) as ReturnType<
    typeof useQuery<TData extends TGetListCASTQuestionConfigResponse ? TGetListCASTQuestionConfigResponse : TData>
  >;
}

// Backward compatibility - deprecated
/**
 * @deprecated Use useGetListCASTQuestionConfigQuery instead
 */
export const useGetListCASTQuestionConfig = useGetListCASTQuestionConfigQuery;
